// extracted by mini-css-extract-plugin
export default {"hideTooltip":"wda-z","fadeIn":"xda-z","delay":"yda-z","recommendedSizeTooltip":"zda-z"};